/* eslint-disable react-hooks/exhaustive-deps */
import { ApiKeyFetch } from "api/fetchers/apiKey";
import BreadCrumb from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import DynamicForm from "components/DynamicForm";
import Page from "components/Page";
import { URLS_PHP_7 } from "constants/urls_v2";
import EmisionFooterBarButtons from "containers/Pymes/emision/EmisionFooterBarButtons";
import { useNavbarContext } from "contexts/NavbarContext";
import useCustomForm from "hooks/useCustomForm";
import React, { useCallback, useEffect, useState } from "react";
import { FormProvider } from "react-hook-form";
import { PASOS_BREADCRUMBS } from "utils/constants";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import { mappRutasEmision } from "utils/funciones";
import Loading from "wrappers/Loading";

const API = ApiKeyFetch.instance();

const HogarEmisionAsegurado = ({
  qParams: { idPoliza, codProducto },
  addWarningToast,
  history,
}) => {
  const methods = useCustomForm({ mode: "onChange" });
  const [catalogo, setCatalogo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [idAsegurado, setIdAsegurado] = useState(null);

  const [routes, setRoutes] = useState({});
  useNavbarContext(PRODUCTOS.HOGAR);

  const init = useCallback(async () => {
    setLoading(true);

    const Body = {
      datosCotizador: {
        polCodigo: idPoliza,
        prodCodigo: codProducto,
        formulario: "asegurado",
        formCodigo: `form${codProducto}Asegurado`,
      },
    };

    const res = await API.post(URLS_PHP_7.emision.catalogoAsegurado, Body);
    console.log(res);
    if (res?.transaccion && res?.catalogo && res?.asegurados) {
      const { catalogo } = res;
      if (!catalogo?.camposAdicionales?.permitirEmitir) {
        addWarningToast("No se puede emitir esta póliza", {
          autoDismiss: false,
        });
      }

      if (res?.asegurados?.[0]) {
        setIdAsegurado(res?.asegurados?.[0]?.id);
        methods.reset({
          ...res?.asegurados?.[0]?.datos,
        });
      }

      setRoutes(mappRutasEmision(catalogo?.pasosRedireccionamiento));
      setCatalogo(catalogo);
    } else {
      addWarningToast("Ha ocurrido un problema al consultar la información");
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  const guardarInformacion = async (data, guardarDatos = true) => {
    setLoading(true);
    const Data = {
      datos: data,
      id: idAsegurado,
      poliza: idPoliza,
      guardarDatos,
    };
    const res = await API.post(URLS_PHP_7.pymesCommon.actualizarAsegurados, Data);
    setLoading(false);
    init();
    console.log("RES: ", res);
    return res;
  };

  const onSubmit = async (data) => {
    console.log("DATA: ", JSON.stringify(data));
    const res = await guardarInformacion(data, false);
    if (res?.transaccion === true) {
      history.push(routes.asegurado.goTo);
    }
  };

  const onGuardar = async () => {
    const isValid = await methods.trigger("tipoPersona");
    if (isValid) {
      const data = methods.getValues();
      console.log("contratante es", data);
      await guardarInformacion(data);
    } else {
      addWarningToast("Debe seleccionar un tipo de persona");
    }
  };

  const onClickAtras = () => {
    history.push(routes.asegurado.goBack);
  };

  const onSubmitError = () => {
    addWarningToast("Rellene el formulario correctamente");
  };

  return (
    <Loading loading={loading}>
      <div className='row justify-content-center mx-2'>
        <div className='col-12'>
          <div className='cr-content'>
            {catalogo && (
              <React.Fragment>
                <FormProvider {...methods}>
                  <form>
                    <Page styles={{ minHeight: "80vh" }}>
                      <React.Fragment>
                        <BreadCrumb {...PASOS_BREADCRUMBS[PRODUCTOS.HOGAR].breadCrumb} />

                        <BreadCrumbPasosV2
                          {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasosEmision[6]}
                          pasos={PASOS_BREADCRUMBS[codProducto].pasosHogarFlex}
                        />
                      </React.Fragment>

                      <DynamicForm {...catalogo?.validaciones} resources={catalogo} />
                    </Page>
                  </form>
                </FormProvider>
                <EmisionFooterBarButtons
                  labelAtras='ATRÁS'
                  onClickAtras={onClickAtras}
                  onClickGuardar={onGuardar}
                  onClickContinuar={methods.handleSubmit(onSubmit, onSubmitError)}
                />
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </Loading>
  );
};

export default HogarEmisionAsegurado;
